import {Link} from '@material-ui/core';

import XingIcon from 'src/Components/Icons/XingIcon';
import EnvHelper from 'src/Utils/EnvHelper';

const XingProfileLink = (props: IXingProfileLinkProps) => (
	<Link
		color="primary"
		underline="none"
		href={EnvHelper.getXingPageUrl()}
		target="_blank"
		rel="noreferrer"
		className={props.linkClassName}
	>
		<XingIcon className={props.iconClassName} />
	</Link>
);

interface IXingProfileLinkProps {
	linkClassName?: string;
	iconClassName?: string;
}

export default XingProfileLink;
